import api from "@/services/api";

// ── HR Service ──────────────────────────────────────────────────────────────
// All endpoints are ready for backend wiring.
// Currently returns mock-compatible promises.

const HR_BASE = "/hr";

export const hrService = {
  // ── Employees ──────────────────────────────────────────────────────────
  getEmployees: (params = {}) => api.get(`${HR_BASE}/employees`, { params }),
  createEmployee: (data) => api.post(`${HR_BASE}/employees`, data),
  updateEmployee: (id, data) => api.put(`${HR_BASE}/employees/${id}`, data),
  deleteEmployee: (id) => api.delete(`${HR_BASE}/employees/${id}`),
  toggleEmployeeStatus: (id) => api.patch(`${HR_BASE}/employees/${id}/toggle`),
  getDashboardStats: () => api.get(`${HR_BASE}/dashboard-stats`),

  // ── Attendance ─────────────────────────────────────────────────────────
  getAttendance: (params = {}) => api.get(`${HR_BASE}/attendance`, { params }),
  markAttendance: (data) => api.post(`${HR_BASE}/attendance`, data),
  updateAttendance: (id, data) => api.patch(`${HR_BASE}/attendance/${id}`, data),
  bulkMarkAttendance: (data) => api.post(`${HR_BASE}/attendance/bulk`, data),

  // ── Leaves ─────────────────────────────────────────────────────────────
  getLeaves: (params = {}) => api.get(`${HR_BASE}/leaves`, { params }),
  createLeave: (data) => api.post(`${HR_BASE}/leaves`, data),
  updateLeaveStatus: (id, status, remarks) =>
    api.patch(`${HR_BASE}/leaves/${id}/status`, { status, remarks }),
  deleteLeave: (id) => api.delete(`${HR_BASE}/leaves/${id}`),
  getLeaveBalance: (employeeId) =>
    api.get(`${HR_BASE}/leaves/balance/${employeeId}`),

  // ── Pay Setup ──────────────────────────────────────────────────────────
  getPaySetups: (params = {}) => api.get(`${HR_BASE}/pay-setup`, { params }),
  getPaySetupByEmployee: (employeeId) =>
    api.get(`${HR_BASE}/pay-setup/${employeeId}`),
  savePaySetup: (employeeId, data) =>
    api.put(`${HR_BASE}/pay-setup/${employeeId}`, data),

  // ── Payslips ───────────────────────────────────────────────────────────
  getPayslips: (params = {}) => api.get(`${HR_BASE}/payslips`, { params }),
  generatePayslip: (data) => api.post(`${HR_BASE}/payslips/generate`, data),
  bulkGeneratePayslips: (data) => api.post(`${HR_BASE}/payslips/bulk-generate`, data),
  updatePayslipStatus: (id, status) =>
    api.patch(`${HR_BASE}/payslips/${id}/status`, { status }),
  deletePayslip: (id) => api.delete(`${HR_BASE}/payslips/${id}`),

  // ── Payments ───────────────────────────────────────────────────────────
  createPaymentOrder: (data) => api.post(`${HR_BASE}/payments/order`, data),
  verifyPaymentSignature: (data) => api.post(`${HR_BASE}/payments/verify`, data),
};
